import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MenuItem from '../LeftBar/MenuItem/MenuItem';
import MenuLogo from '../LeftBar/MenuLogo/MenuLogo';
import {
  getDefaultInfoTheme,
  getDomain,
} from 'Store/MultiDomain/MultiDomain.selector';
import { loadImage } from 'Utils/MultidomailUtils';
import { AdmLeftBarStyled } from './styles';

import logoCoordlyCollapse from 'Static/images/logo-coordly-collapsed.png';

export interface IAdmLeftBar {
  isCollapsed: boolean;
}

const AdmLeftBar: FC<IAdmLeftBar> = ({ isCollapsed }) => {
  const { t } = useTranslation('sidebar');

  const domain = useSelector(getDomain);
  const defaultDomain = useSelector(getDefaultInfoTheme);

  const [, setCounter] = useState(0);
  const [, setOpenList] = useState(false);

  return (
    <AdmLeftBarStyled isCollapsed={`${isCollapsed}`}>
      <MenuLogo
        image={loadImage(domain?.LogoUrl || defaultDomain?.LogoUrl || 'logo-coodly.svg', false)}
        imageCollapse={logoCoordlyCollapse}
        isCollapsed={isCollapsed}
        domain={domain}
      />

      <MenuItem
        icon="buildingScryscraper"
        title={t('adm.tenants')}
        path="tenants"
        redirect="/adm/tenants"
        isCollapsed={isCollapsed}
        onCounter={setCounter}
        onOpenList={setOpenList}
      />
      <MenuItem
        icon="coinsMoney"
        title={t('adm.planos')}
        path="planos"
        redirect="/adm/planos"
        isCollapsed={isCollapsed}
        onCounter={setCounter}
        onOpenList={setOpenList}
      />
      <MenuItem
        icon="phases"
        title={t('adm.stages')}
        path="stages"
        redirect="/adm/stages"
        isCollapsed={isCollapsed}
        onCounter={setCounter}
        onOpenList={setOpenList}
      />

      <MenuItem
        icon="listDetailVision"
        title={t('adm.disciplinas')}
        path="disciplinas"
        redirect="/adm/disciplinas"
        isCollapsed={isCollapsed}
        onCounter={setCounter}
        onOpenList={setOpenList}
      />
    </AdmLeftBarStyled>
  );
};

export default AdmLeftBar;
